import { Stack } from 'canoe';
import React, { useEffect } from 'react';

import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';
import { useDownloadAnalyticsQuery } from '@candu-ai/analytics/ui';

import { ContentSummaryList } from './ContentSummaryList';
import { ContentTimeChart } from './ContentTimeChart';
import { MultiseriesApi } from './MultiseriesApi';
import { useGetAnalyticsQuery } from './useGetAnalyticsQuery';

interface Props {
  queryId: QueryId;
  queryParams: QueryParamUrlObject;
  title: string;
  legend: string;
  aggregateQueryId?: QueryId;
  syncId?: string;
  tooltipText?: string;
  unit?: '%';
  multiseriesApi?: MultiseriesApi;
  seriesName?: string;
  withTotalPrefix?: boolean;
}

export const TimeseriesGraph = ({
  queryId,
  queryParams,
  title,
  legend,
  aggregateQueryId,
  syncId,
  tooltipText,
  multiseriesApi,
  unit,
  seriesName,
  withTotalPrefix,
}: Props) => {
  const [data, aggregateData, onRefreshQuery, isLoadingQuery] = useGetAnalyticsQuery<any>({
    queryId,
    queryParams,
    aggregateQueryId,
  });
  const { download: onDownloadWithoutTimeseries } = useDownloadAnalyticsQuery(queryParams as any);
  const onDownloadViews = async () => {
    const url = await onDownloadWithoutTimeseries({ queryId });
    window.open(url);
  };

  useEffect(() => {
    if (!multiseriesApi || !data || !aggregateData) {
      return;
    }
    multiseriesApi.onQueriesHaveLoaded(data, aggregateData);
  }, [multiseriesApi, data, aggregateData]);

  return (
    <Stack spaceAfter="xl">
      <ContentTimeChart
        tooltipText={tooltipText}
        syncId={syncId}
        title={title}
        legend={legend}
        rawData={data}
        onDownloadData={onDownloadViews}
        onRefreshQuery={onRefreshQuery}
        multiseriesApi={multiseriesApi}
        unit={unit}
        isLoading={isLoadingQuery}
      />
      {data && aggregateData && (
        <ContentSummaryList
          rawData={aggregateQueryId ? aggregateData : data}
          multiseriesApi={multiseriesApi}
          unit={unit}
          title={title}
          seriesName={seriesName}
          withTotalPrefix={withTotalPrefix}
        />
      )}
    </Stack>
  );
};
